import { get } from 'lodash'
import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
import StoreLoader from '../Elements/StoreLoader'
import StoreTranslate from './StoreTranslate'

// Same lookup as useTranslate, callable outside React — stores need it to put display-ready text in
// the Errors block, which renders plain strings as-is and would otherwise show a raw dictionary key.
export function translateKey(key, options = { defaultDisplay: null }, fallback = 'en') {
    const { defaultDisplay } = options || {}

    const fallbackLanguage = `${fallback}.${key}`

    let translated = get(StoreTranslate.Dictionaries(), `${StoreTranslate.CurrentLanguage().toLowerCase()}.${key}`, key)

    if (translated === key) {
        translated = get(StoreTranslate.Dictionaries(), fallbackLanguage, defaultDisplay ? defaultDisplay : key)
    }

    return translated
}

export function useTranslate(fallback = 'en') {
    return (key, options) => translateKey(key, options, fallback)
}

export function useTranslateStaticComponents(fallback = 'en') {
    function translateStaticComponents(key, options = { defaultDisplay: null }) {
        const { defaultDisplay } = options || {}

        const fallbackLanguage = `${fallback}.${key}`
        
        let translated = get(StoreTranslate.GetDictionaryStaticComponents(), `${StoreTranslate.CurrentLanguage().toLowerCase()}.${key}`, '')

        if (translated === key) {
            translated = get(StoreTranslate.GetDictionaryStaticComponents(), fallbackLanguage, defaultDisplay ? defaultDisplay : '')
        }

        return translated
    }

    return translateStaticComponents
}

export const T = observer(({ children, defaultDisplay }) => {
    const translate = useTranslate()
    return <>{StoreLoader.dictionary && translate(children, { defaultDisplay })}</>
})
